import { LANGUAGES, LOCALE_KEY, USED_LANGUAGES, languageToDateFnsLocale } from 'shared/constants/languages';

export const LanguageService = {
  initLanguage: (): void => {
    const currentLanguage = LanguageService.getCurrentLanguage();
    setLanguage(currentLanguage);
  },

  getCurrentLanguage: (): string => {
    try {
      return localStorage.getItem(LOCALE_KEY) || LANGUAGES.english;
    } catch {
      return LANGUAGES.english;
    }
  },

  getCurrentLanguageLocale: (): Locale => {
    return languageToDateFnsLocale[LanguageService.getCurrentLanguage()];
  },

  changeLanguage: (locale?: string): void => {
    const currentLanguage = LanguageService.getCurrentLanguage();
    if (currentLanguage === locale) return;
    if (locale && USED_LANGUAGES.includes(locale)) {
      setLanguage(locale);
      window.location.reload();
      return;
    }

    const newLanguage = currentLanguage === LANGUAGES.english ? LANGUAGES.french : LANGUAGES.english;
    setLanguage(newLanguage);
    window.location.reload();
  }
};

const setLanguage = (language: string) => {
  if (!USED_LANGUAGES.includes(language)) return;
  try {
    localStorage.setItem(LOCALE_KEY, language);
  } catch {
    return;
  }
};
